/**
 * @Author: DKing
 * @Desc: 所有的api接口
 * @Date: 2019-07-15
 */
import {get,post} from './axios_service.js';
import {INTERFACE_URL} from "./interface_urls";

//新闻咨询列表
export const getNewAndInfoList = params => get(INTERFACE_URL.INFORMATION_LIST, params, 'json');
//新闻详情
export const getNewAndInfoDetail = params => get(INTERFACE_URL.INFORMATION_DETAIL, params, 'json');
// 百度转化追踪-官网电话点击
export const getCallOc = params => get(INTERFACE_URL.CALL_OC, params, 'json');
//预约
export const postMakeAppoint = params => post(INTERFACE_URL.MAKE_APPOINT, params, 'json');
//查询省市接口
export const postFindProvinceOrCity = params => post(INTERFACE_URL.FIND_PROVINCE_OR_CITY, params, 'form');


// WEBPACK FOOTER //
// ./src/service/apis.js